import { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useGetInventoryByIdRequest, useWhoAmIQueryRequest } from '../../hooks/useApi';

export const useInventoryManagement = () =>
{
  const {inventoryId} = useParams();

  // Get posId from changeStoreParams (selected via Change Store button in Topbar)
  const changeStoreParams = JSON.parse(localStorage.getItem('changeStoreParams'));
  const posId = changeStoreParams?.selectedPosId;

  const [{data, loading, error}, getInventoryById] = useGetInventoryByIdRequest(posId);
  const [{data: whoAmI}] = useWhoAmIQueryRequest();

  useEffect(() =>
  {
    if (inventoryId && posId)
    {
      getInventoryById({
        queryParams: {inventoryId: parseInt(inventoryId, 10)}
      });
    }
  }, [inventoryId, posId, getInventoryById]);

  // Parse data if it's a JSON string
  const parsedInventory = data ? (typeof data === 'string' ? JSON.parse(data) : data) : null;

  const parsedWhoAmI = useMemo(() =>
  {
    if (!whoAmI) return null;
    if (typeof whoAmI === 'string')
    {
      try
      {
        return JSON.parse(whoAmI);
      } catch
      {
        return null;
      }
    }
    return whoAmI;
  }, [whoAmI]);

  const isHqUser = parsedWhoAmI?.isHqUser || false;

  const refetch = useCallback(() =>
  {
    if (inventoryId && posId)
    {
      getInventoryById({ queryParams: { inventoryId: parseInt(inventoryId, 10) } });
    }
  }, [inventoryId, posId, getInventoryById]);

  return {
    inventory: parsedInventory,
    isHqUser,
    loading,
    error,
    refetch
  };
};
